// removed by extract-text-webpack-plugin
module.exports = {"syncbtn":"syncbtn","checktrue":"checktrue","checkfalse":"checkfalse","disabled":"disabled","slideblock":"slideblock"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Form/SwitchButton.scss
// module id = 194
// module chunks = 0